"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFiltersByProductAndProvider = void 0;
var productFiltersDictionary = null;
var generateProductFiltersDictionary = function (configsList) {
    return configsList.reduce(function (dictionary, filter) {
        filter.products.forEach(function (product) {
            if (!dictionary[product]) {
                dictionary[product] = [];
            }
            dictionary[product].push(filter);
        });
        return dictionary;
    }, {});
};
var findProductFilters = function (configsList, productName) {
    if (!productFiltersDictionary) {
        productFiltersDictionary = generateProductFiltersDictionary(configsList);
    }
    return productFiltersDictionary[productName];
};
var findFiltersByProductAndProvider = function (configsList, productName, providersList) {
    var providerFilters = findProductFilters(configsList, productName);
    return providerFilters.filter(function (filter) {
        return providersList.every(function (provider) {
            return filter.providers.includes(provider);
        });
    });
};
exports.findFiltersByProductAndProvider = findFiltersByProductAndProvider;
//# sourceMappingURL=findFiltersByProductAndProvider.js.map